// Loading spinner component
export function LoadingSpinner() {
	return (
		<output
			aria-label="Loading"
			className="min-h-screen flex items-center justify-center bg-background-subtle"
		>
			<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
		</output>
	);
}
